import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import BurgerMenu from '../../commons/BurgerMenu';
import Header from '../../commons/Header';
import { ReactComponent as IconBuilding } from '../../images/icn_buildings.svg';
import { Col, Nav, NavItem, NavLink, Row } from 'reactstrap';
import {
  BtnRadiusWhite,
  ContFlexLeft,
  H4Styled,
} from '../../styled-components';
import { useHistory } from 'react-router-dom';
import { ReactComponent as IconBack } from '../../images/icn-back.svg';
import variables from '../../variables';
import classNames from 'classnames';
import { Link, Route, Switch, Redirect } from 'react-router-dom';
import SignalsAdminCondos from './SignalsAdminCondo';
import SignalsAdminSpecialJobs from './SignalsAdminSpecialJobs';
import SignalsAdminRentalsSales from './SignalsAdminRentalsSales';

const SignalsPresentational = ({
  data,
  profile,
  newIsAdmin,
  query,
  total,
  onFilter,
  location,
  match = {},
  setQuery,
}) => {
  const [t] = useTranslation('SIGNALS');
  const { year, limit, offset } = query;
  const history = useHistory();

  const { url = '' } = match;
  const { pathname = '', state = {} } = location;
  const tab = pathname.split('/').pop();

  const totals = Array.isArray(data)
    ? data.reduce(
        (acc, signal) => {
          return {
            totalExtraShare:
              acc.totalExtraShare + Number(signal?.extraShare || 0),
            totalSignalmanShare:
              acc.totalSignalmanShare + Number(signal?.signalmanShare || 0),
            totalEstimate: acc.totalEstimate + Number(signal?.estimate || 0),
            totalCommercialShare:
              acc.totalCommercialShare + Number(signal?.commercial?.share || 0),
            totalCommercial2Share:
              acc.totalCommercial2Share +
              Number(signal?.commercial2?.share || 0),
            totalCommercial3Share:
              acc.totalCommercial3Share +
              Number(signal?.commercial3?.share || 0),
          };
        },
        {
          totalExtraShare: 0,
          totalSignalmanShare: 0,
          totalEstimate: 0,
          totalCommercialShare: 0,
          totalCommercial2Share: 0,
          totalCommercial3Share: 0,
        }
      )
    : {
        totalExtraShare: 0,
        totalSignalmanShare: 0,
        totalEstimate: 0,
        totalCommercialShare: 0,
        totalCommercial2Share: 0,
        totalCommercial3Share: 0,
      };

  if (pathname === url) {
    return <Redirect to={`${url}/condos${location.search}`} />;
  }

  return (
    <div className="App">
      <BurgerMenu />

      <div className="corpo">
        <section>
          <Header
            title={`Rendicontazione segnalazioni - ${year}`}
            icon={<IconBuilding fill="#ffffff" style={{ height: '25px' }} />}
          />

          <Row className="align-items-center">
            <Col md="12" lg="6">
              <ContFlexLeft>
                <BtnRadiusWhite onClick={() => history.replace('/dashboard')}>
                  <IconBack fill={variables.primary} />
                </BtnRadiusWhite>

                <H4Styled>Segnalazioni</H4Styled>
              </ContFlexLeft>
            </Col>
          </Row>
        </section>

        <section>
          <div className="m-tb-20">
            <Nav tabs>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}/condos?signalTypeCode=CONDO`}
                  className={classNames({ active: tab === 'condos' })}
                >
                  {t('PAGES:SIGNALS_CONDO_TAB')}
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}/special-jobs?signalTypeCode=SPECIAL_JOBS`}
                  className={classNames({ active: tab === 'special-jobs' })}
                >
                  {t('PAGES:SIGNALS_SPECIAL_JOBS_TAB')}
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}/rentals-sales?signalTypeCode=RENTALS_SALES`}
                  className={classNames({ active: tab === 'rentals-sales' })}
                >
                  {t('PAGES:SIGNALS_RENTALS_SALES_TAB')}
                </NavLink>
              </NavItem>
            </Nav>

            <Switch>
              <Route
                path={`${match.url}/condos`}
                component={(props) => (
                  <SignalsAdminCondos
                    data={data}
                    query={query}
                    total={total}
                    onFilter={onFilter}
                    totals={totals}
                    {...props}
                  />
                )}
              />

              <Route
                path={`${match.url}/special-jobs`}
                component={(props) => (
                  <SignalsAdminSpecialJobs
                    data={data}
                    query={query}
                    total={total}
                    onFilter={onFilter}
                    totals={totals}
                    {...props}
                  />
                )}
              />
              <Route
                path={`${match.url}/rentals-sales`}
                component={(props) => (
                  <SignalsAdminRentalsSales
                    data={data}
                    query={query}
                    total={total}
                    onFilter={onFilter}
                    totals={totals}
                    {...props}
                  />
                )}
              />
            </Switch>
          </div>
        </section>
      </div>
    </div>
  );
};

export default SignalsPresentational;
